<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header-with-filters">
      <d-row
        no-gutters
        class="page-header py-4">
        <d-col
          col
          sm="6"
          class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
          <h3 class="page-title">{{ $t('settings.transaltion.dictionaryMultilang') }}</h3>
        </d-col>
        <d-col
          col
          sm="6"
          class="text-right text-sm-right d-flex justify-content-end align-items-end">
          <d-button
            theme="secondary"
            @click.prevent="$router.push('/ustawienia')">
            <i class="material-icons">arrow_back</i>
            {{ $t('settings.backToSettings') }}
          </d-button>
        </d-col>
      </d-row>

      <list-filters
        :config="filtersConfig"
        :isListLoaded="loaded"
        :view-name="'translations'"
        @init="handleFiltersInit"
        @search="handleFiltersSearch" />
    </div>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">{{ $t('settings.transaltion.systemName') }}</th>
            <th
              scope="col"
              class="border-0">{{ $t('settings.transaltion.valueInPolish') }}</th>
            <th
              scope="col"
              class="border-0">{{ $t('settings.transaltion.transaltionStatus') }}</th>
            <th
              scope="col"
              class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(translation, index) of translations"
            :key="'translation-' + index">
            <td class="align-middle">
              {{ translation.value }}
            </td>
            <td
              class="align-middle"
              v-pure-html="translation.translation">
            </td>
            <td
              class="align-middle"
              v-pure-html="translationStatus(translation.translations)"></td>
            <td
              class="align-middle"
              style="width: 80px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/slowniki-wielojezycznosci/edycja/' + translation.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="translations.length === 0">
            <td
              colspan="4"
              class="text-center">
              {{ $t('settings.transaltion.noTranslationsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a
          href="javascript:window.location.reload();"
        class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import cloneDeep from 'lodash.clonedeep';

export default {
  name: 'translations',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    filtersConfig () {
      return [
        {
          key: 'search',
          apiKey: 'search',
          label: this.$t('ui.search'),
          placeholder: this.$t('settings.phraseSearchPlaceholder'),
          type: 'text',
          isBasic: true,
          defaultValue: ''
        }
      ];
    }
  },
  data () {
    return {
      translations: [],
      loaded: false,
      loadError: false,
      activeFilters: {},
      apiQueryPayload: {}
    };
  },
  mounted () {},
  methods: {
    handleFiltersInit (filters, apiPayload) {
      this.activeFilters = filters;
      this.apiQueryPayload = apiPayload;

      this.loadFilteredData();
    },
    handleFiltersSearch (activeFilters, apiPayload) {
      this.activeFilters = activeFilters;
      this.apiQueryPayload = apiPayload;
      this.$bus.$emit('pagination-reset');
      this.debouncedLoadFilteredData();
    },
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = cloneDeep(this.apiQueryPayload) || {};

      ListUtils.loadPaginatedItemsData(this, {
        method: 'get',
        endpoint: '/translations/items?page=' + this.currentPage,
        listField: 'translations',
        params: {
          where
        }
      });
    },
    translationStatus (translationsToCheck) {
      let isTranslated = true;
      let missingTranslationsCount = 0;

      for (let i = 0; i < translationsToCheck.length; i++) {
        let translation = translationsToCheck[i];

        if (translation.translation === '') {
          isTranslated = false;
          missingTranslationsCount++;
        }
      }

      if (isTranslated) {
        return '<span class="text-success">' + this.$t('settings.transaltion.translated') + '</span>';
      }

      if (missingTranslationsCount === 1) {
        return '<span class="text-danger">' + this.$t('settings.transaltion.missingTranslationsIn') + '1 ' + this.$t('settings.language.languageLocative') + ' </span>';
      }

      return '<span class="text-danger">' + this.$t('settings.transaltion.missingTranslationsIn') + missingTranslationsCount + ' ' + this.$t('settings.language.languagesLocative') + '</span>';
    }
  }
};
</script>
